import { Outlet } from "react-router";
import Header from "../../../component/layout/header";
import useNav from "../../../script/tabingNavArray";

const SaleLayout = () => {
  const navList = useNav();
  let { saleBottomNav, saleTopNav } = navList;
  return (
    <div className="webBody">
      <Header bottomTabs={saleBottomNav} topTabs={saleTopNav} />
      <Outlet />
    </div>
  )
}

export default SaleLayout;